import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { query } from "firebase/firestore";
import { set } from "date-fns";
import WarningButton from "../buttons/WarningButton.js";
import modifyFolderPack from "../api/modify/modifyFolderPack.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import sendConformityReport from "../api/send/sendConformityReport.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import getControlPresginedUrls from "../api/presigned/getControlPresignedUrls.js";
import DropDownGPTM3 from "../dropdowns/DropDownGPTM3.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import sendIntermediaryReport from "../api/send/sendIntermediaryReport.js";

const Intermediary = ({ document, folder, orgData, onClose, onUpdate }) => {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loadingData, setLoadingData] = useState(false);
  const [controls, setControls] = useState([]);
  const [control_options, setControlOptions] = useState([]);
  const [selected_control, setSelectedControl] = useState({});
  const [categories_selected, setCategoriesSelected] = useState([]);
  const [categories_options, setCategoriesOptions] = useState([]);
  const [payment_options, setPaymentOptions] = useState([]);
  const [selected_payment, setSelectedPayment] = useState(null);
  const [slot_options, setSlotOptions] = useState([]);
  const [selected_slot, setSelectedSlot] = useState(null);
  useEffect(() => {
    handleFetchData();
    if (folder.payment_allowed) {
      handleFetchPayments();
    } else {
      handleFetchSlots();
    }
  }, []);

  const handleFetchData = async () => {
    let control_filters = [
      {
        field: "folder_ref",
        operator: "==",
        value: folder.ref,
      },
    ];
    const controls = (await queryCollection("control", control_filters)) || [];
    if (controls.length === 0) {
      handleClickVariant("Le dossier n'a pas de contrôles associés", "error");
      onClose();

      return;
    }
    if (
      folder.payment_allowed &&
      (!folder.reglement.payments || folder.reglement.payments.length === 0)
    ) {
      handleClickVariant(
        "Comme c'est un dossier avec paiement particulier, il faut créer un paiement pour pouvoir lancer le RTB",
        "error"
      );
      onClose();
    }
    setControls(controls);
    const control_options = controls.map((control) => {
      return {
        value: control.id,
        label:
          control.name +
          " - " +
          new Date(control.date.seconds * 1000).toLocaleString(),
      };
    });

    setControlOptions(control_options);
  };

  const handleFetchPayments = async () => {
    if (!folder.payment_allowed || !folder.reglement?.payments?.length) return;
    const payments = [];
    for (let i = 0; i < folder.reglement.payments.length; i++) {
      const paymentData = await getDocDataByRef(folder.reglement.payments[i]);
      payments.push({
        value: paymentData.id,
        label: paymentData.title || "Emplacement de paiement " + (i + 1),
      });
    }
    setPaymentOptions(payments);
    if (payments.length > 0) {
      setSelectedPayment(payments[payments.length - 1].value);
    }
  };

  const handleFetchSlots = async () => {
    if (!folder.rapport?.slots?.length) return;
    const slots = [];
    for (let i = 0; i < folder.rapport.slots.length; i++) {
      const slotData = await getDocDataByRef(folder.rapport.slots[i]);
      slots.push({
        value: slotData.id,
        label: slotData.title || "Emplacement de rapport " + (i + 1),
      });
    }
    setSlotOptions(slots);
    if (slots.length > 0) {
      setSelectedSlot(slots[slots.length - 1].value);
    }
  };

  const handleConformityReport = async () => {
    let token = await getOrRefreshFirebaseToken();
    if (!folder.conductor_id && !folder.particulier?.email && folder.folder_type == "infiltro") {
      handleClickVariant(
        "Le dossier n'a pas de conducteur de chantier alors qu'il n'est pas lié à un particulier",
        "error"
      );

      return;
    }
    if (!folder.members_id || folder.members_id.length == 0) {
      handleClickVariant("Le dossier n'a pas d'opétateur", "error");
      return;
    }
    if (!folder.xml?.file?.id) {
      handleClickVariant("Le dossier n'a pas de fichier xml", "error");
      return;
    }
    token = await getOrRefreshFirebaseToken();

    setLoadingData(true);
    const res = await sendIntermediaryReport(
      folder.id,
      selected_control,
      token,
      prefix,
      handleClickVariant,
      selected_payment,
      selected_slot,
    );
    if (res.success) {
        handleClickVariant("Rapport de contrôle généré", "success");
    }
    setLoadingData(false);
    onUpdate();
    onClose();
  };

  return (
    <div className="flex flex-col  bg-white rounded-3xl  w-c600 max-w-[80vw]">
      <div className="text-h3 flex flex-row justify-between p-4 border-b-1">
        Générer un rapport de test intermédiaire
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>
      <div className="flex flex-col gap-4 p-4 bg-neutral-50">
        <div className="w-c300 text-h3 text-shadow_50">
          Sélectionnez un contrôle pour générer un rapport de test intermédiaire
        </div>
        <DropDownGPT03
          label="Control"
          className="w-full"
          value={selected_control}
          items={control_options}
          onChange={(e) => {
            setSelectedControl(e.value);
          }}
        ></DropDownGPT03>
        {folder.payment_allowed && payment_options.length > 0 && (
          <DropDownGPT03
            label="Onglet de paiement"
            className="w-full"
            value={selected_payment}
            items={payment_options}
            onChange={(e) => setSelectedPayment(e.value)}
          ></DropDownGPT03>
        )}
        {!folder.payment_allowed && slot_options.length > 0 && (
          <DropDownGPT03
            label="Emplacement de rapport"
            className="w-full"
            value={selected_slot}
            items={slot_options}
            onChange={(e) => setSelectedSlot(e.value)}
          ></DropDownGPT03>
        )}
      </div>

      <div className="flex flex-row  justify-end p-4 border-t-1">
        <PrimaryButton
          className={"w-fit"}
          onClick={handleConformityReport}
          disabled={loadingData}
        >
          Générer le rapport <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Intermediary;
